import { AuthorizationList } from './enums';

const MENU_PARENT = {
    ADMIN: '/admin',
};

export const ROUTES = {
    ADMIN_DASHBOARD: MENU_PARENT.ADMIN,
    LOGIN: '/login',
    RESET_PWD: '/reset-password',
};

export const ROUTES_SUPER_ADMIN = {
    CONTRACT: {
        PATH: '/contract',
        NAME: 'LBL020048',
    },
};

export const ROUTES_PRIVATE = {
    DASHBOARD: {
        ID: AuthorizationList.DASHBOARD,
        PATH: '/dashboard',
        NAME: 'LBL030023',
    },
    CONTAINER_COLLECTION: {
        ID: AuthorizationList.CONTAINER_COLLECTION,
        PATH: '/container-collection',
        NAME: 'LBL030022',
    },
    INSTALLATION: {
        ID: AuthorizationList.INSTALLATION,
        PATH: '/installations',
        NAME: 'LBL030001',
    },
    COLLECTION: {
        ID: AuthorizationList.COLLECTION,
        PATH: '/collections',
        NAME: 'LBL030002',
    },
    RESTOCK: {
        ID: AuthorizationList.RESTOCK,
        PATH: '/receiving',
        NAME: 'LBL030003',
    },
    MOVING: {
        ID: AuthorizationList.MOVING,
        PATH: '/moving',
        NAME: 'LBL030004',
    },
    PROCESSING: {
        ID: AuthorizationList.PROCESSING,
        PATH: '/processing',
        NAME: 'LBL030005',
    },
    SHIPPING: {
        ID: AuthorizationList.SHIPPING,
        PATH: '/export',
        NAME: 'LBL030006',
    },
    UNIT_INTEGRATION: {
        ID: AuthorizationList.UNIT_INTEGRATION,
        PATH: '/unit-integration',
        NAME: 'LBL030021',
    },
    CONTAINER: {
        ID: AuthorizationList.UNIT,
        PATH: '/containers',
        NAME: 'LBL030007',
    },
    TRACE: {
        ID: AuthorizationList.TRACE,
        PATH: '/traces',
        NAME: 'LBL030008',
    },
    INVENTORY: {
        ID: AuthorizationList.INVENTORY_MANAGEMENT,
        PATH: '/inventories',
        NAME: 'LBL030009',
    },
    INVENTORY_PROGRESS: {
        ID: AuthorizationList.INVENTORY,
        PATH: '/inventory-progress',
        NAME: 'LBL030018',
    },
    INVENTORY_PERFORMANCE: {
        ID: AuthorizationList.INVENTORY,
        PATH: '/inventory-performance',
        NAME: 'LBL030019',
    },
    MANAGEMENT: {
        ID: AuthorizationList.MANAGEMENT,
        PATH: '/',
        NAME: 'LBL030010',
        CHILDREN: {
            USER: {
                PATH: '/users',
                NAME: 'LBL030011',
            },
            CONTAINER_TYPE: {
                PATH: '/container-type',
                NAME: 'LBL030012',
            },
            CONTENT: {
                PATH: '/content',
                NAME: 'LBL030013',
            },
            COMPANY: {
                PATH: '/company',
                NAME: 'LBL030014',
            },
            LOCATION: {
                PATH: '/location',
                NAME: 'LBL030015',
            },
            PROCESSING_WORK: {
                PATH: '/processing-work',
                NAME: 'LBL030016',
            },
        },
    },
    HISTORY: {
        ID: AuthorizationList.WORK_HISTORY,
        PATH: '/work-history',
        NAME: 'LBL030017',
    },
    MASTER_HISTORY: {
        ID: AuthorizationList.MANAGEMENT,
        PATH: '/master-history',
        NAME: 'LBL030020',
    },
    PRINT_SETTING: {
        ID: AuthorizationList.UNDEFINED,
        PATH: '/print-setting',
        NAME: 'LBL000009',
    },
    EXTERNAL_API_KEY: {
        ID: AuthorizationList.UNDEFINED,
        PATH: '/external-api-key',
        NAME: 'LBL290001',
    },
    EXTERNAL_IP_WHITELIST: {
        ID: AuthorizationList.UNDEFINED,
        PATH: '/external-ip-whitelist',
        NAME: 'LBL290002',
    },
    THRESHOLD_SETTING: {
        ID: AuthorizationList.UNDEFINED,
        PATH: '/threshold-setting',
        NAME: 'LBL270015',
    },
    THRESHOLD_ALERT: {
        ID: AuthorizationList.UNDEFINED,
        PATH: '/threshold-alert',
        NAME: 'LBL270014',
    },
};
